(() => {
  const photoTone = root => {
    const back = root.querySelector('[data-photo-back]');
    const image = root.querySelector('.native-product__frame img:not(.native-product__tile)');
    if (!back || !image?.complete || !image.naturalWidth) return;
    try {
      const canvas = document.createElement('canvas');
      canvas.width = 12; canvas.height = 6;
      const context = canvas.getContext('2d', { willReadFrequently: true });
      context.drawImage(image, 0, 0, image.naturalWidth * .4, image.naturalHeight * .18, 0, 0, 12, 6);
      const pixels = context.getImageData(0, 0, 12, 6).data;
      let total = 0;
      for (let i = 0; i < pixels.length; i += 4) {
        const alpha = pixels[i + 3] / 255;
        total += (pixels[i] * .299 + pixels[i + 1] * .587 + pixels[i + 2] * .114) * alpha + 243 * (1 - alpha);
      }
      back.classList.toggle('photo-back--on-dark', total / (pixels.length / 4) < 128);
    } catch (_) { /* Cross-origin media keeps the server's photo-colour choice. */ }
  };
  document.querySelectorAll('[data-native-product]').forEach(root => {
    const image = root.querySelector('.native-product__frame img:not(.native-product__tile)');
    if (image) { image.addEventListener('load', () => photoTone(root)); photoTone(root); }
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-native-variant]');
    if (!select) return;
    const root = select.closest('[data-native-product]');
    const option = select.selectedOptions[0];
    const button = root.querySelector('[data-native-add]');
    root.querySelector('[data-native-price]').textContent = option.dataset.price;
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
    const quantity = root.querySelector('[name="quantity"]');
    quantity.min = option.dataset.min;
    quantity.step = option.dataset.step;
    if (option.dataset.max) quantity.max = option.dataset.max;
    else quantity.removeAttribute('max');
    quantity.value = option.dataset.min;
    const url = new URL(location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
    if (option.dataset.image) {
      const image = root.querySelector('.native-product__frame img:not(.native-product__tile)');
      if (image) { image.src = option.dataset.image; image.removeAttribute('srcset'); image.alt = option.dataset.imageAlt; }
    }
    const back = root.querySelector('[data-photo-back]');
    if (back) back.classList.toggle('photo-back--on-dark', option.dataset.backDark === 'true');
    photoTone(root);
  });
  const underlay = document.querySelector('.native-product__tile');
  const sharp = underlay && underlay.parentElement.querySelector('.native-product__full');
  if (sharp) {
    const drop = () => { if (sharp.complete && sharp.naturalWidth > 0) underlay.remove(); };
    if (sharp.complete) drop();
    else sharp.addEventListener('load', drop, { once: true });
  }
})();

/* Editorial collection filter sheet/menu. App v140 still owns every filter input and redraw. */
(function () {
  'use strict';
  var doc = document, win = window, html = doc.documentElement;
  if (html.getAttribute('data-io-flook') !== 'rail' || !win.HTMLDialogElement || !win.MutationObserver) return;
  var copy = {
    en: { done: 'Done', close: 'Close filters' }, fr: { done: 'Terminé', close: 'Fermer les filtres' },
    de: { done: 'Fertig', close: 'Filter schließen' }, es: { done: 'Listo', close: 'Cerrar filtros' },
    it: { done: 'Fatto', close: 'Chiudi filtri' }, ja: { done: '完了', close: 'フィルターを閉じる' }
  };
  var lang = (html.lang || 'en').toLowerCase().split('-')[0], words = copy[lang] || copy.en;
  var rooms = [], desktopMedia = win.matchMedia('(min-width: 750px)');
  function desktop() { return desktopMedia.matches; }
  function one(tag, cls) { var n = doc.createElement(tag); n.className = cls; return n; }
  function labelFor(item) { var label = item && item.querySelector('.io-filter__label'); return label ? label.textContent.trim() : ''; }
  function isCollection(root) { return !!(root.getAttribute('data-io-collection') || '').trim(); }
  function setup(root) {
    if (root.__ioSheet || !isCollection(root)) return;
    var probe = doc.createElement('dialog'); if (typeof probe.showModal !== 'function') return;
    var pills = root.querySelector('[data-io-pills]'); if (!pills) return;
    var dialog = one('dialog', 'io-filter-sheet'); dialog.setAttribute('aria-modal', 'true'); dialog.setAttribute('data-voisson-filter-sheet', '');
    var title = one('h2', 'io-filter-sheet__title'), head = one('div', 'io-filter-sheet__head');
    title.id = 'io-filter-sheet-title-' + rooms.length; title.setAttribute('data-voisson-filter-title', ''); dialog.setAttribute('aria-labelledby', title.id);
    var close = one('button', 'io-filter-sheet__close'); close.type = 'button'; close.setAttribute('aria-label', words.close);
    close.setAttribute('data-voisson-filter-close', '');
    close.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5 19 19M19 5 5 19"/></svg>';
    head.appendChild(title); head.appendChild(close);
    var body = one('div', 'io-filter-sheet__body');
    var foot = one('div', 'io-filter-sheet__foot'), count = one('span', 'io-filter-sheet__count');
    var done = one('button', 'io-filter-sheet__done'); done.type = 'button'; done.textContent = words.done; done.setAttribute('data-voisson-filter-done', '');
    foot.appendChild(count); foot.appendChild(done); dialog.appendChild(head); dialog.appendChild(body); dialog.appendChild(foot);
    root.appendChild(dialog);
    var s = { root: root, pills: pills, dialog: dialog, title: title, body: body, count: count, done: done,
      key: '', initial: null, initialHome: null, initialNext: null, initialProxy: null, rail: null, frame: 0, closing: 0,
      lock: null, lastInput: null, observer: null, backdropDown: false, backdropReady: false, dead: false,
      layout: '', restoreFocus: true, focusPending: false, inputWasInSheet: false, switching: false, toggleClosed: false, tabPending: false,
      abort: new AbortController() };
    root.__ioSheet = s; rooms.push(s); root.setAttribute('data-io-sheet-ready', '');

    function schedule() { if (!s.dead && !s.frame) s.frame = win.requestAnimationFrame(function () { s.frame = 0; sync(s); }); }
    root.addEventListener('click', function (event) {
      var trigger = event.target.closest && event.target.closest('.io-filter__name');
      if (!trigger || !pills.contains(trigger)) return;
      if (trigger.closest('.io-filter-sheet__proxy')) return;
      var wrap = trigger.closest('[data-io-filter]');
      s.toggleClosed = !!(s.dialog.open && wrap && wrap.getAttribute('data-io-filter') === s.key);
      s.switching = true;
      s.focusPending = event.detail === 0 && desktop();
      // Catalog and flook finish their own click handlers and move the real panel before this frame.
      schedule();
    }, true);
    root.addEventListener('toggle', function (event) { if (event.target.matches && event.target.matches('[data-io-initial-filter]')) schedule(); }, true);
    root.addEventListener('change', function (event) {
      var input = event.target;
      if (dialog.open && body.contains(input) && input.matches('input')) {
        s.lastInput = { type: input.type, value: input.value, node: input };
        schedule();
      }
    }, true);
    close.addEventListener('click', function () { dismiss(s, false, true); });
    done.addEventListener('click', function () { dismiss(s, false, true); });
    dialog.addEventListener('cancel', function (event) { event.preventDefault(); dismiss(s, false, true); });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'Tab') s.tabPending = true;
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); dismiss(s, false, true); }
    });
    dialog.addEventListener('pointerdown', function (event) { s.backdropDown = event.target === dialog; s.backdropReady = false; });
    dialog.addEventListener('pointerup', function (event) { s.backdropReady = s.backdropDown && event.target === dialog; s.backdropDown = false; });
    dialog.addEventListener('pointercancel', function () { s.backdropDown = false; s.backdropReady = false; });
    dialog.addEventListener('click', function (event) {
      if (event.target === dialog && s.backdropReady && s.layout === 'mobile') dismiss(s, false, true);
      s.backdropReady = false;
    });
    dialog.addEventListener('focusin', function () { s.inputWasInSheet = true; });
    dialog.addEventListener('focusout', function () {
      if (s.layout !== 'desktop') return;
      win.requestAnimationFrame(function () {
        if (s.dialog.open && s.layout === 'desktop' && s.tabPending && !s.switching && !s.dialog.contains(doc.activeElement)) dismiss(s, true, false);
        s.tabPending = false;
      });
    });
    dialog.addEventListener('close', function () { if (!s.dialog.open) finish(s); });
    doc.addEventListener('pointerdown', function (event) {
      if (!s.dialog.open || s.layout !== 'desktop' || s.dialog.contains(event.target)) return;
      var chip = event.target.closest && event.target.closest('.io-filter__name');
      if (chip && s.pills.contains(chip)) { s.switching = true; return; }
      dismiss(s, true, false);
    }, { capture: true, signal: s.abort.signal });
    doc.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && s.dialog.open && s.layout === 'desktop') {
        event.preventDefault(); event.stopPropagation(); dismiss(s, true, true);
      }
    }, { capture: true, signal: s.abort.signal });
    win.addEventListener('resize', function () { if (s.dialog.open) { if (desktop() !== (s.layout === 'desktop')) dismiss(s, true, false); else positionMenu(s); } }, { signal: s.abort.signal });
    win.addEventListener('scroll', function () { if (s.dialog.open && s.layout === 'desktop') positionMenu(s); }, { capture: true, signal: s.abort.signal });
    s.observer = new MutationObserver(schedule);
    s.observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'open', 'hidden', 'aria-expanded'], characterData: true });
    sync(s);
  }

  function lock(s) {
    if (s.lock) return;
    var b = doc.body, y = win.scrollY;
    s.lock = { y: y, position: b.style.position, top: b.style.top, left: b.style.left, right: b.style.right, width: b.style.width };
    b.style.position = 'fixed'; b.style.top = '-' + y + 'px'; b.style.left = '0'; b.style.right = '0'; b.style.width = '100%';
  }
  function unlock(s) {
    if (!s.lock) return;
    var b = doc.body, old = s.lock; s.lock = null;
    b.style.position = old.position; b.style.top = old.top; b.style.left = old.left; b.style.right = old.right; b.style.width = old.width;
    win.scrollTo(win.scrollX, old.y);
  }
  function focusChip(s) {
    var items = s.pills.querySelectorAll('[data-io-filter], [data-io-initial-filter]'), target = null;
    Array.prototype.forEach.call(items, function (item) { if ((item.getAttribute('data-io-filter') || item.getAttribute('data-io-initial-filter')) === s.key) target = item.querySelector('.io-filter__name'); });
    if (target) { try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); } }
  }
  function restoreInitial(s) {
    if (!s.initial) return;
    s.initial.open = false;
    if (s.initialHome && s.initialHome.isConnected) s.initialHome.insertBefore(s.initial, s.initialNext && s.initialNext.parentNode === s.initialHome ? s.initialNext : null);
    else s.initial.remove();
    if (s.initialProxy) s.initialProxy.remove();
    s.initialProxy = null;
    s.initial = null; s.initialHome = null; s.initialNext = null;
  }
  function closeFilter(s) {
    var items = s.pills.querySelectorAll('[data-io-filter]');
    Array.prototype.forEach.call(items, function (item) {
      if (item.getAttribute('data-io-filter') === s.key && item.classList.contains('is-open')) {
        item.classList.remove('is-open'); var button = item.querySelector('.io-filter__name'); if (button) button.setAttribute('aria-expanded', 'false');
      }
    });
    restoreInitial(s);
  }
  function finish(s) {
    if (s.closing) { win.clearTimeout(s.closing); s.closing = 0; }
    s.dialog.classList.remove('is-closing');
    closeFilter(s); unlock(s); if (s.restoreFocus && !s.dead) focusChip(s);
    s.dialog.style.width = ''; s.dialog.style.left = ''; s.dialog.style.top = '';
    s.key = ''; s.lastInput = null; s.focusPending = false; s.inputWasInSheet = false; s.layout = ''; s.switching = false; s.toggleClosed = false; s.tabPending = false;
  }
  function dismiss(s, immediate, restoreFocus) {
    s.restoreFocus = restoreFocus !== false;
    if (!s.dialog.open) { finish(s); return; }
    if (s.closing) return;
    if (immediate) { s.dialog.close(); finish(s); return; }
    s.dialog.classList.add('is-closing');
    s.closing = win.setTimeout(function () { s.closing = 0; if (s.dialog.open) { s.dialog.close(); finish(s); } }, win.matchMedia('(prefers-reduced-motion: reduce)').matches ? 100 : 150);
  }
  function positionMenu(s) {
    if (!s.dialog.open || s.layout !== 'desktop') return;
    var item = null, controls = s.pills.querySelectorAll('[data-io-filter], [data-io-initial-filter]');
    Array.prototype.forEach.call(controls, function (x) { if ((x.getAttribute('data-io-filter') || x.getAttribute('data-io-initial-filter')) === s.key) item = x; });
    var anchor = item && item.querySelector('.io-filter__name');
    if (!anchor && s.initialProxy && s.initialProxy.isConnected) anchor = s.initialProxy.querySelector('.io-filter__name');
    if (!anchor) return;
    var rect = anchor.getBoundingClientRect();
    if (rect.bottom < 0 || rect.top > win.innerHeight) { dismiss(s, true, false); return; }
    var width = Math.min(320, win.innerWidth - 24), gap = 8;
    s.dialog.style.width = width + 'px';
    var height = s.dialog.getBoundingClientRect().height;
    var left = Math.max(12, Math.min(rect.left, win.innerWidth - width - 12));
    var above = rect.bottom + gap + height > win.innerHeight - 8 && rect.top >= height + gap + 8;
    var top = above ? rect.top - height - gap : rect.bottom + gap;
    top = Math.max(8, Math.min(top, win.innerHeight - height - 8));
    s.dialog.style.left = left + 'px'; s.dialog.style.top = top + 'px';
  }
  function focusMenu(s) {
    if (!s.focusPending || s.layout !== 'desktop' || !s.dialog.open) return;
    var target = s.body.querySelector('.io-filter__panel input:not([disabled]),.io-filter__panel button:not([disabled]),[data-io-initial-filter] button:not([disabled])');
    if (!target) target = s.dialog.querySelector('.io-filter-sheet__close');
    if (target) { try { target.focus({ preventScroll: true }); } catch (_) { target.focus(); } }
    s.focusPending = false;
  }
  function open(s, key, item) {
    if (!key || !item || s.closing) return;
    s.key = key;
    var heading = labelFor(item); if (heading && s.title.textContent !== heading) s.title.textContent = heading;
    if (!s.dialog.open) {
      s.layout = desktop() ? 'desktop' : 'mobile'; s.dialog.setAttribute('data-io-filter-layout', s.layout);
      if (s.layout === 'desktop') s.dialog.removeAttribute('aria-modal'); else s.dialog.setAttribute('aria-modal', 'true');
      s.restoreFocus = s.layout === 'mobile';
      if (s.layout === 'mobile') { s.dialog.style.width = ''; s.dialog.style.left = ''; s.dialog.style.top = ''; }
      s.dialog.classList.add('is-entering');
      try { if (s.layout === 'desktop') s.dialog.show(); else s.dialog.showModal(); } catch (_) { s.dialog.classList.remove('is-entering'); return; }
      s.dialog.getBoundingClientRect();
      win.requestAnimationFrame(function () { s.dialog.classList.remove('is-entering'); });
      if (s.layout === 'mobile') {
        lock(s);
        // The close button is the first focus stop; native dialog keeps focus inside thereafter.
        s.dialog.querySelector('.io-filter-sheet__close').focus({ preventScroll: true });
      }
    }
    if (s.layout === 'desktop') positionMenu(s);
  }
  function sync(s) {
    if (s.dead || !s.root.isConnected) return;
    if (s.toggleClosed && s.dialog.open) { s.toggleClosed = false; dismiss(s, true, true); }
    var rail = s.root.querySelector('.io-fl__rail');
    if (rail && rail.parentNode !== s.body) { s.body.appendChild(rail); s.rail = rail; }
    var initialOpen = s.pills.querySelector('[data-io-initial-filter][open]') || (s.initial && s.initial.open && s.initial.isConnected ? s.initial : null);
    var loadedOpen = s.pills.querySelector('[data-io-filter].is-open');
    // The first server control can open before flook starts, so its private openKey is absent.
    // Keep this one selected after a later app redraw without duplicating any input or data.
    if (!loadedOpen && s.dialog.open && s.key && !s.closing) {
      var replacements = s.pills.querySelectorAll('[data-io-filter]');
      Array.prototype.forEach.call(replacements, function (item) {
        if (item.getAttribute('data-io-filter') === s.key) {
          item.classList.add('is-open'); var button = item.querySelector('.io-filter__name'); if (button) button.setAttribute('aria-expanded', 'true'); loadedOpen = item;
        }
      });
    }
    if (initialOpen && !loadedOpen) {
      if (!s.initial) {
        s.initial = initialOpen; s.initialHome = initialOpen.parentNode; s.initialNext = initialOpen.nextSibling;
        if (desktop()) {
          // Keep a real, reachable trigger in the row while the native Loading/Retry details moves intact.
          var proxy = one('span', 'io-filter is-open io-filter-sheet__proxy'), trigger = one('button', 'io-filter__name');
          trigger.type = 'button'; trigger.setAttribute('aria-expanded', 'true');
          var text = one('span', 'io-filter__label'); text.textContent = labelFor(initialOpen); trigger.appendChild(text);
          trigger.addEventListener('click', function () { if (s.initial) s.initial.open = false; dismiss(s, true, true); });
          proxy.appendChild(trigger); s.initialHome.insertBefore(proxy, initialOpen); s.initialProxy = proxy;
        }
        s.body.appendChild(initialOpen);
      }
      open(s, initialOpen.getAttribute('data-io-initial-filter'), initialOpen);
    } else if (loadedOpen) {
      // Hydration has replaced the native Loading control. Keep only the app's one real panel.
      if (s.initial) { s.initial.remove(); if (s.initialProxy) s.initialProxy.remove();
        s.initial = null; s.initialHome = null; s.initialNext = null; s.initialProxy = null; }
      open(s, loadedOpen.getAttribute('data-io-filter'), loadedOpen);
    } else if (s.dialog.open && !s.closing) {
      dismiss(s);
    }
    var currentCount = s.root.querySelector('[data-io-count]');
    var nextCount = currentCount ? currentCount.textContent.trim() : '';
    if (s.count.textContent !== nextCount) s.count.textContent = nextCount;
    if (s.lastInput && s.dialog.open) {
      var controls = s.body.querySelectorAll('input'); var found = null;
      Array.prototype.forEach.call(controls, function (input) { if (input.type === s.lastInput.type && input.value === s.lastInput.value) found = input; });
      if (found && found !== s.lastInput.node) {
        if (!s.body.contains(doc.activeElement)) { try { found.focus({ preventScroll: true }); } catch (_) { found.focus(); } }
        s.lastInput = null;
      }
    }
    // Retry or a replaced input can disappear while the modal stays open.
    // Preserve focus on surviving controls; otherwise restore a stable in-sheet stop.
    if (s.dialog.open && !s.closing && !s.dialog.contains(doc.activeElement) &&
      (s.layout === 'mobile' || (s.layout === 'desktop' && s.inputWasInSheet && (doc.activeElement === doc.body || doc.activeElement === html)))) {
      var fallback = s.dialog.querySelector('.io-filter-sheet__close');
      try { fallback.focus({ preventScroll: true }); } catch (_) { fallback.focus(); }
    }
    if (s.dialog.open && s.layout === 'desktop') { positionMenu(s); focusMenu(s); }
    s.switching = false;
  }
  function teardown(s) {
    if (s.dead) return;
    s.dead = true; s.abort.abort(); if (s.frame) win.cancelAnimationFrame(s.frame); s.observer.disconnect();
    if (s.closing) { win.clearTimeout(s.closing); s.closing = 0; }
    if (s.dialog.open) s.dialog.close();
    restoreInitial(s); unlock(s); s.key = ''; s.lastInput = null;
    // A history-restored document keeps this root and flook's pointer to the same rail.
    if (s.rail && s.rail.parentNode === s.body) s.root.appendChild(s.rail);
    s.dialog.remove(); s.root.removeAttribute('data-io-sheet-ready'); delete s.root.__ioSheet;
  }
  function start() {
    if (html.getAttribute('data-io-flook') !== 'rail') return;
    Array.prototype.forEach.call(doc.querySelectorAll('[data-io-filters][data-io-inside]'), setup);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  doc.addEventListener('shopify:section:load', function () { start(); });
  doc.addEventListener('shopify:section:unload', function (event) { rooms.forEach(function (s) { if (event.target.contains(s.root)) teardown(s); }); });
  win.addEventListener('pagehide', function () { rooms.forEach(teardown); });
  win.addEventListener('pageshow', start);
})();
